import axios from "axios";
import { APP_DATA } from "../config/settings";

// v2 data plane (api2.smilefy.app / patient-service-v2). Mirrors the swebapp
// apiClientV2: same base, and `Authorization: Bearer <idToken>` (the v2 backend
// authorizer REQUIRES the Bearer prefix). Used to write patients/cases/files
// into the app's store from SmileFy Drive.
const V2_BASE =
  process.env.REACT_APP_API_BASE_URL_V2 ||
  process.env.REACT_APP_AUTH_SERVICE_URL ||
  "https://api2.smilefy.app";

const instanceV2 = axios.create({ baseURL: V2_BASE });

instanceV2.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("idToken");
    if (token) req.headers["Authorization"] = `Bearer ${token}`;
    return req;
  },
  (error) => Promise.reject(error)
);

instanceV2.interceptors.response.use(undefined, function (err) {
  if (err.response && (err.response.status === 403 || err.response.status === 401)) {
    window.location.href = window.location.origin + "/#" + APP_DATA.LOGIN_ROUTE;
  }
  return Promise.reject(err);
});

export default instanceV2;
